<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  statusCode: HttpStatusCode
  statusMessage?: string
  description?: string
  error?: NuxtError | Error
  class?: string
}>()

const emit = defineEmits<{
  (e: 'clear'): void
}>()
</script>

<template>
  <section
    :class="
      cn(
        'fixed left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2',
        props.class,
      )
    "
  >
    <div class="mx-auto max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
      <div class="mx-auto max-w-screen-sm text-center">
        <h1
          class="mb-4 text-7xl font-extrabold tracking-tight text-primary-400 lg:text-9xl"
        >
          {{ (error as NuxtError)?.statusCode ?? statusCode }}
        </h1>
        <p
          class="mb-4 text-3xl font-bold tracking-tight text-white md:text-4xl"
        >
          {{
            (error as NuxtError)?.statusMessage ??
            statusMessage ??
            HTTP_ERROR_MESSAGE[statusCode]
          }}
        </p>
        <p
          v-if="description || HTTP_ERROR_DESCRIPTION[statusCode] || error"
          class="mb-4 text-base font-light text-gray-200 sm:text-lg"
        >
          {{ description || HTTP_ERROR_DESCRIPTION[statusCode] || error }}
        </p>
        <Button as-child @click="emit('clear')">
          <NuxtLink to="/"> Go back home </NuxtLink>
        </Button>
      </div>
    </div>
  </section>
</template>
